/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Avatar1/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import Avatar from 'DesignSystem/Avatar/index'
import React from 'react'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Avatar1({
  children,
  viewPath = "/App/ChooseUser/Users/Content/User/Avatar"
  
}) {
let userVaxiomPersonValueData = fromData.useDataFormat({ viewPath,
context: 'user',
path: 'vaxiom_person',
format: fromFormat.initials,
})
  return (<React.Fragment
>
<Avatar
  viewPath={`${viewPath}/Avatar`}
 data="user.vaxiom_person"
 format="/Data/format.js initials"
 initials={userVaxiomPersonValueData}
 size="large"
/>
{children}
</React.Fragment>)
}